import { render, staticRenderFns } from "./CommaCaution.vue?vue&type=template&id=2cca1734&scoped=true"
import script from "./CommaCaution.vue?vue&type=script&lang=js"
export * from "./CommaCaution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca1734",
  null
  
)

export default component.exports